import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { useState } from 'react';
import App from './App';
import Login from './pages/Login';
// import { Provider } from 'react-redux';
// import store from '../public/store/store'
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";import AuditHome from './pages/AuditHome';
import ClinicalReview from './pages/ClinicalReview';

import { UserContextProvider } from './components/Common/UserContext';
// ReactDOM.render(
//   <React.StrictMode>
//     <UserContextProvider>
//     {isAuthenticated ? <App /> : <Login />}
//     </UserContextProvider>   
//   </React.StrictMode>,
//   document.getElementById('root')
// );
const AuthApp = () => {
  // Assume you have a state to track authentication status
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  return (
    <React.StrictMode>
      <UserContextProvider>
        {/* Conditionally render components based on authentication status */}
        {/* <Router> */}
  
    <App />

       

      {/* </Router> */}
      
      </UserContextProvider>
    </React.StrictMode>
  );
};

ReactDOM.render(<AuthApp />, document.getElementById('root'));
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
